import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Facebook, Instagram, Twitter } from "lucide-react";

const LOGO = "https://customer-assets-4nw71qhi.emergentagent.net/job_build-hub-1023/artifacts/0xoh0nsf_logo%20ETI.jpeg";

const Footer = () => (
  <footer className="bg-[#0a0c0f] border-t border-white/10 mt-24" data-testid="main-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
      <div className="col-span-2">
        <span className="bg-white rounded-md px-2 py-1 inline-flex"><img src={LOGO} alt="Exclusive Trades Inc" className="h-8 w-auto" /></span>
        <p className="mt-4 text-sm text-slate-400 max-w-xs leading-relaxed">
          The one-stop industrial marketplace connecting homeowners, verified contractors, laborers, realtors, investors and cargo drivers — with escrow and progress tracking on every job.
        </p>
        <div className="flex gap-3 mt-5">
          {[Linkedin, Facebook, Instagram, Twitter].map((Icon, i) => (
            <a key={i} href="#" className="h-9 w-9 rounded-md border border-white/10 flex items-center justify-center text-slate-400 hover:text-primary hover:border-primary transition-colors" data-testid={`footer-social-${i}`}>
              <Icon className="h-4 w-4" />
            </a>
          ))}
        </div>
      </div>
      <div>
        <h4 className="text-sm font-bold text-white mb-4 uppercase tracking-wide">Marketplace</h4>
        <ul className="space-y-2.5 text-sm text-slate-400">
          <li><Link to="/marketplace" className="hover:text-primary">Contractor Jobs</Link></li>
          <li><Link to="/marketplace" className="hover:text-primary">Cargo Delivery Board</Link></li>
          <li><Link to="/real-estate" className="hover:text-primary">Real Estate & Investors</Link></li>
          <li><Link to="/pricing" className="hover:text-primary">Membership Plans</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="text-sm font-bold text-white mb-4 uppercase tracking-wide">Company</h4>
        <ul className="space-y-2.5 text-sm text-slate-400">
          <li><Link to="/about" className="hover:text-primary">About Us</Link></li>
          <li><Link to="/how-it-works" className="hover:text-primary">How It Works</Link></li>
          <li><Link to="/contact" className="hover:text-primary">Contact</Link></li>
          <li><a href="#" className="hover:text-primary">Trust & Safety</a></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center text-xs text-slate-500">
      © {new Date().getFullYear()} Exclusive Trades Inc. All rights reserved. Built for builders.
    </div>
  </footer>
);

export default Footer;
